/**
 * 菜品 `item_type` 与菜单库 / 集团搜索表一致；文案 key 对齐 `menu-library-management-state.getDishTypeLabel`。
 * （移动端同名文件在 Shell2-Mobile，6/7 的 key 可能不同，勿混用仓库。）
 */

/** 单选项：value 与接口 `item_type` 一致 */
export type MenuLibraryDishItemTypeOption = {
    /** RBP 菜品类型数值 */
    value: number;
    /** i18n 文案 key */
    labelKey: string;
};

/**
 * 与 `ITEM_TYPE` 一致，含调味品 `1`。
 */
export const MENU_LIBRARY_DISH_ITEM_TYPE_OPTIONS: readonly MenuLibraryDishItemTypeOption[] = [
    { value: 0, labelKey: 'menu_and_dishes_page_normal_dishes' },
    { value: 1, labelKey: 'settings_page_text_condiment' },
    { value: 2, labelKey: 'menu_and_dishes_page_dish_with_current_price' },
    { value: 3, labelKey: 'menu_and_dishes_page_set_meal' },
    { value: 4, labelKey: 'menu_and_dishes_page_custom' },
    { value: 5, labelKey: 'menu_and_dishes_page_text' },
    { value: 6, labelKey: 'menu_and_dishes_page_weight_dish' },
    { value: 7, labelKey: 'menu_and_dishes_page_timed_dish' },
];
